import React from "react";
import { Card, Text } from "components";
import { MiniCheck } from "../icons";

/**
 * A creation-path card (AI featured or DIY). `featured` uses the spotlight Card
 * treatment; `cta` is the button node so callers control variant + onClick.
 */
const PathCard = ({ featured, iconClass, icon, badge, title, desc, bullets, cta, fineprint }) => (
  <Card spotlight={featured} interactive padding="lg" style={{ display: "flex", flexDirection: "column" }}>
    <div className="cg-path-top">
      <span className={`cg-path-icon ${iconClass}`}>{icon}</span>
      {badge}
    </div>
    <Text variant="h3" className="cg-path-title">{title}</Text>
    <Text variant="body" tone="muted" className="cg-path-desc">{desc}</Text>
    <ul className="cg-path-bullets">
      {bullets.map((b) => (
        <li key={b}><span className="tick"><MiniCheck /></span> {b}</li>
      ))}
    </ul>
    <div className="cg-path-cta">
      {cta}
      <div className="cg-path-fineprint">{fineprint}</div>
    </div>
  </Card>
);

export default PathCard;
